import styled from 'styled-components'

export const PropertyHorizontalOptionsWrap = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.colors.senary};

  .grid-atom {
    margin: 0 !important;
  }

  .card-image-atom {
    height: 13.5rem;
    width: 17rem;
  }

  .box-content {
    flex: 1;
    grid-gap: 0;

    .column-left {
      padding: 2.25rem;
      border-right: 0.125rem solid ${props => props.theme.colors.borderPrimary};

      .button-scheduled {
        margin-left: 3rem;
        margin-top: 0.625rem;
      }
    }

    .column-center {
      display: flex;
      flex-direction: column;
      justify-content: center;

      padding: 2.25rem;
      border-right: 0.125rem solid ${props => props.theme.colors.borderPrimary};
    }

    .column-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      padding: 2.25rem;

      .button-atom a,
      .button-atom button {
        width: 100%;
      }
    }
  }
`
